<script>
	import { onDestroy, onMount } from "svelte";
	import { nav } from "./store.js";
	let article;
	let articles;

	
	onMount(() => {
		const wipeout = document.querySelector(".wipeout");
		wipeout.style.visibility = "hidden";
		wipeout.style.transform = "translateX(0%)";

		// Run the animation
		const container = article.children[0];
		const contrect = container.getBoundingClientRect();
		let containerMidX = contrect.left + container.clientWidth / 2;
		let containerMidY = contrect.top + container.clientHeight / 2;

		container.children[0].style.transform =
			"translateX(-10%)";
		container.children[1].style.transform =
			"translateX(10%)";
		container.children[2].style.transform = "translateX(-80%) ";
		container.children[0].style.transition = "all 0.8s ease";
		container.children[1].style.transition = "all 0.8s ease";
		container.children[2].style.transition = "all 0.8s ease";

		setTimeout(() => {
			container.children[0].style.transform = "";
			container.children[0].style.opacity = "1";
		}, 333);
		setTimeout(() => {
			container.children[1].style.transform = "";
			container.children[1].style.opacity = "1";
		}, 666);
		setTimeout(() => {
			container.children[2].style.transform = "";
			container.children[2].style.opacity = "1";
		}, 1000);
	});
	

	function wipe(navfunc) {
		const wipeout = document.querySelector(".wipeout");
		wipeout.style.visibility = "visible";
		wipeout.style.transform = "translateX(-102%)";
		setTimeout(navfunc, 800);
	}
</script>

<section>
	<article class="head" bind:this={article}>
		<div>
			<h1>
				Some Token
			</h1>
			<h2>
				Some tokens, the owner of the last 1,000,000 tokens
				will get the jackpot of 100,000 BNB!
			</h2>
			<a on:click={(e)=>{ if (window.screen.width > 980) { e.preventDefault(); wipe(() => {  nav.set("vault") })}}} href="https://cointool.app/ido/exchange?id=236b722b27777726262021267750227127242424262b242a272b245077222a2b51277525572a202226726f2625">
				<svg
					width="31"
					height="24"
					viewBox="0 0 31 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M30.0607 13.0607C30.6464 12.4749 30.6464 11.5251 30.0607 10.9393L20.5147 1.3934C19.9289 0.807612 18.9792 0.807612 18.3934 1.3934C17.8076 1.97918 17.8076 2.92893 18.3934 3.51472L26.8787 12L18.3934 20.4853C17.8076 21.0711 17.8076 22.0208 18.3934 22.6066C18.9792 23.1924 19.9289 23.1924 20.5147 22.6066L30.0607 13.0607ZM0 13.5H29V10.5H0V13.5Z"
						fill="#FF7A22"
					/>
				</svg>
				<h3>Buy Now</h3>
			</a>
		</div>
	</article>
	<div class="info" bind:this={articles}>
		<article class="info">
		
				<h1><span style="color:#FF7A22">1</span></h1>
				<p>
					Some token “A game of chance that doesn't need
					luck.” It is a token with a hold and win policy. It promises
					to award 100,000 BNB when the amount of tokens circulating as
					a result of the burns drops to 1,000,000. If 1,000,000
					tokens are at a single address, the entire prize is
					distributed, and if it is in a scattered form, such as
					800,000-200,000, the distribution takes place according to
					the percentage share in the last 1,000,000 tokens. After the
					pre-sale, the team aims to speed up the process by burning
					regularly.
				</p>
		
		</article>
		<article class="info">
		
				<h1>2</h1>
				<p>
					When all tokens are sold, listing will begin on the pancake,
					user will be able to trade only on decentralized exchanges
					at the free exchange rate.
				</p>
	
		</article>
		<article class="info">
		
				<h1><span style="color:#22F3FF">3</span></h1>
				<p>
					The BNB obtained when all tokens are sold will be kept in the BNB vault on the binance platform. With 0.35% stake income excluding extra rewards, the expected return of 100,000 BNB will be 14 BNB per month. Of this amount, 10 BNB will be used to repurchase and burn the Some Token listed on the decentralized exchange. The remaining approximately 4 BNB will be used for unplanned distributions and promotions.

				</p>
	
		</article>
		<article class="info">
	
				<h1><span style="color:#FF7A22">4</span></h1>
				<p>
					User will be included in the pool where 1% of the transactions made is distributed, while keeping the token in their wallet to win the big prize. User will be able to get a share from this distribution as much as the amount of tokens they keep in their wallet. Since the amount of tokens required for the grand prize is 1,000,000, user will be able to earn passive income by selling the Some Tokens that come to their wallet as a hodler reward on the decentralized exchange, or continue to accumulate in their wallet in order to obtain more tokens from the hodler reward.
				</p>

		</article>
	</div>



		<img id="background" src="./Wawe1.svg" alt="" />

		<div class="lht-container">
		<svg
			id="LHT"
			width="366"
			height="222"
			viewBox="0 0 366 222"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				id="lht-t"
				d="M273.24 50.3849L248.4 65.671L258.214 111.809M273.24 50.3849L289.916 56.9789M273.24 50.3849L283.141 96.2432M293.042 142.102L268.029 157.947M293.042 142.102L308.328 146.618M293.042 142.102L283.141 96.2432M268.029 157.947L283.836 162.946L308.328 146.618M268.029 157.947L258.214 111.809M308.328 146.618L299.158 101.976M289.916 56.9789L326.394 71.4033L329.173 86.8631M289.916 56.9789L293.042 72.2006M293.042 72.2006L329.173 86.8631M293.042 72.2006L298.445 98.5014M329.173 86.8631L309.371 102.844L298.445 98.5014M298.445 98.5014L299.158 101.976M299.158 101.976L283.141 96.2432M283.141 96.2432L258.214 111.809"
				stroke="#FFF2E6"
				stroke-width="2"
			/>
			<path
				id="lht-h"
				d="M160.331 50.3849L134.97 65.671L144.09 111.809M160.331 50.3849L175.27 55.4224L181.359 85.2997M160.331 50.3849L169.277 95.1141M193.856 146.618L178.223 139.843M193.856 146.618L169.364 165.031L153.209 157.947M193.856 146.618L190.316 129.247M178.223 139.843L153.209 157.947M178.223 139.843L169.277 95.1141M153.209 157.947L144.09 111.809M144.09 111.809L169.277 95.1141M181.359 85.2997L184.758 101.976M181.359 85.2997L187.95 88.1771M184.758 101.976L222.694 116.914M184.758 101.976L190.316 129.247M210.88 60.6335L225.123 65.671L243.884 157.947M210.88 60.6335L184.758 76.4408L187.95 88.1771M210.88 60.6335L219.558 101.976M229.987 151.655L205.668 167.636M229.987 151.655L243.884 157.947M229.987 151.655L222.694 116.914M205.668 167.636L219.044 173.89L243.884 157.947M205.668 167.636L199.241 132.895M199.241 132.895L222.694 116.914M199.241 132.895L190.316 129.247M222.694 116.914L219.558 101.976M219.558 101.976L187.95 88.1771"
				stroke="#FFF2E6"
				stroke-width="2"
			/>
			<path
				id="lht-l"
				d="M62.5347 45L37 60.6335L47.4223 106.666M62.5347 45L77.4734 50.3849L87.0273 97.1117M62.5347 45L72.2623 91.2057M87.0273 97.1117L72.2623 91.2057M87.0273 97.1117L92.9333 125.426M72.2623 91.2057L47.4223 106.666M72.2623 91.2057L81.6424 135.848M47.4223 106.666L56.9762 151.655M81.6424 135.848L96.1852 142.102M81.6424 135.848L56.9762 151.655M133.754 158.256L131.322 142.102L92.9333 125.426M133.754 158.256L96.1852 142.102M133.754 158.256L110.999 173.89L72.2623 157.947M92.9333 125.426L96.1852 142.102M96.1852 142.102L72.2623 157.947M56.9762 151.655L72.2623 157.947"
				stroke="#FFF2E6"
				stroke-width="2"
			/>
		</svg>
	</div>
	<div
		on:click={() => {
			wipe(() => nav.set("market"));
		}}
		class="navbutton"
	>
		<svg
			width="31"
			height="24"
			viewBox="0 0 31 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M30.0607 13.0607C30.6464 12.4749 30.6464 11.5251 30.0607 10.9393L20.5147 1.3934C19.9289 0.807612 18.9792 0.807612 18.3934 1.3934C17.8076 1.97918 17.8076 2.92893 18.3934 3.51472L26.8787 12L18.3934 20.4853C17.8076 21.0711 17.8076 22.0208 18.3934 22.6066C18.9792 23.1924 19.9289 23.1924 20.5147 22.6066L30.0607 13.0607ZM0 13.5H29V10.5H0V13.5Z"
				fill="#FF7A22"
			/>
		</svg>
	</div>
	<div on:click={()=>{wipe(() => (nav.set("home")))}} class="navbutton2">
		<svg width="31" height="24" viewBox="0 0 31 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M30.0607 13.0607C30.6464 12.4749 30.6464 11.5251 30.0607 10.9393L20.5147 1.3934C19.9289 0.807612 18.9792 0.807612 18.3934 1.3934C17.8076 1.97918 17.8076 2.92893 18.3934 3.51472L26.8787 12L18.3934 20.4853C17.8076 21.0711 17.8076 22.0208 18.3934 22.6066C18.9792 23.1924 19.9289 23.1924 20.5147 22.6066L30.0607 13.0607ZM0 13.5H29V10.5H0V13.5Z" fill="#FF7A22"/>
		</svg> 
	</div>
</section>

<style>
	@keyframes lht-move {
		0% {
			transform: translateY(-15px);
		}
		50% {
			transform: translateY(18px);
		}
		100% {
			transform: translateY(-15px);
		}
	}
	section {
		width: 100vw;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: flex-start;

		overflow: hidden;
	}

	article.head {
		width: 40vw;
		height: 80vh;
		position: relative;
		margin-left: 3rem;
		margin-top: 14vh; 
		text-align: left;

		transition: all 0.3s ease;
	}
	article.head div {
		
		width: 100%;
		height: 100%;
		
		display: flex;
		align-items: flex-start;
		justify-content: center;
		gap: 2rem;
		flex-direction: column;

	}
	article.head div h1 {
		width: 100%;
		margin: 0;
		padding: 0 1rem;
	
		opacity: 0;
		font-size: 1.8rem;
		text-transform: uppercase;
		transition: all 0.3s ease;
	}
	article.head div h2 {
		padding: 0 1rem;
		width: 100%;
		margin: 0;

		opacity: 0;
		font-size: 0.9rem;
		text-transform: uppercase;
		
		font-style: italic;

		transition: all 0.3s ease;

		text-align: left;
	}
	article.head div a {
		min-width: 10rem;
		margin-left: 1rem;
		opacity: 0;

		text-decoration: none;
		color: white;

		display: flex;
		align-items: center;
		justify-content: center;
		padding: 1rem 2rem;
		border-radius: 50vh;
		border: 2px solid white;
		transition: all 0.3s ease;
	}
	article.head div a:hover {
		text-decoration: none;
		color: #ff7a22;
		background: white;
	}
	article.head div a svg {
		height: 1rem;
		width: auto;
	}
	article.head div a h3 {
		font-size: 1rem;
		margin: 0;
		margin-left: 1rem;
		white-space: nowrap;
	}


	div.info{
		width: 45vw;
		height: 80vh;
		position: absolute;
		top: 14vh;
		right: 3rem;
		padding: 1rem 2rem;
		
		overflow-y: scroll;
		border-radius: 10px;
		background-color: rgba(0, 0, 0, 0.25);
		
		-webkit-box-shadow: inset 0px -25px 20px -30px #000; 
		box-shadow: inset 0px -25px 20px -30px #000;

		
  		scrollbar-width: 5px;

	}
	div.info::-webkit-scrollbar{
		width:5px;
		height: 2rem;
	}
	div.info::-webkit-scrollbar-track {
  		display: none;
	}
	div.info::-webkit-scrollbar-thumb {
 		background: #444;
  		border-radius: 5px
	}
	div.info::-webkit-scrollbar-thumb:hover {
  		background: #666; 
	}	


	article.info {
		border-radius: 10px;
		margin: 3rem 0;
		padding: 0 1rem;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	article.info:hover {
		background-color: rgba(0, 0, 0, 0.50);
	}
	article.info:nth-of-type(even){
		flex-direction: row-reverse;
	}
	article.info h1 {
		padding: 1rem;
		font-size: 2.7rem;
	}
	article.info p {
		font-size: 1rem;
	}


	img#background {
		position: absolute;
		bottom: -2%;
		left: -2%;
		z-index: -10;

		width: 45vw;
		height: 90vh;
		transform: scaleY(180%) translateY(2%);
		opacity: 0.5;
	}
	.lht-container {
		position: absolute;
		bottom: 0rem;
		left: 30%;
		z-index: 70;

		padding: 1rem;
		border-radius: 10px;
	}
	svg#LHT {
		z-index: -5;
		height: 6rem;
		width: auto;
	}

	svg#LHT #lht-t {
		animation-name: lht-move;
		animation-duration: 4.5s;
		animation-iteration-count: infinite;
	}
	svg#LHT #lht-l {
		animation-name: lht-move;
		animation-duration: 4s;
		animation-iteration-count: infinite;
	}
	svg#LHT #lht-h {
		animation-name: lht-move;
		animation-duration: 4.2s;
		animation-iteration-count: infinite;
	}

	.navbutton {
		position: absolute;
		width: 3rem;
		height: 3rem;
		top: 50%;
		left: 100%;
		transform: translate(-80%, -50%);

		display: flex;
		align-items: center;
		justify-content: flex-start;
		padding-left: 0.5rem;
		background-color: rgba(0, 0, 0, 0.5);
		border-radius: 50vh;
		transition: all 0.3s ease;
		cursor: pointer;
	}
	.navbutton svg {
		width: 1.5rem;
		height: 2rem;
	}
	.navbutton:hover{
		transform: translate(-90%, -50%) scale(140%);
		background-color: rgba(0, 0, 0, 0.75);
	}
	.navbutton2{
		position: absolute;
		width: 3rem;
		height: 3rem;
		top: 50%;
		right: 100%;
		transform: translate(80%, -50%);

		display: flex;
		align-items: center;
		justify-content: flex-start;
		padding-left: 0.9rem;
		background-color: rgba(0, 0, 0, 0.5);
		border-radius: 50vh;
		transition: all 0.3s ease;
		cursor: pointer;
	}
	.navbutton2 svg{
		width: 1.5rem;
		height: 2rem;
		transform: rotate(180deg);
	}
	.navbutton2:hover{
		transform: translate(90%, -50%) scale(140%);
		background-color: rgba(0, 0, 0, 0.75);
	}
	@media only screen and (max-width: 1200px){
		
		img#background {
			position: absolute;
			/* changed */
			bottom: -5%;
			left: -2%;
			z-index: -10;

			/* changed */
			width: 92vw;
			/* changed */
			height: 90vh;
			/* changed */
			transform: scaleY(120%);
			opacity: 0.5;
		}
	}

	@media only screen and (max-width: 1000px){


		article.head {
			/* changed */
			margin-top: 16vh; 
		}
		article.head div {
			/* changed */
			gap: 1rem;
		}
		article.head div h1 {
			width: 100%;
			margin: 0;
			padding: 0 1rem;

			opacity: 0;
			/* changed */
			font-size: 1.6rem;
			text-transform: uppercase;
			transition: all 0.3s ease;
		}
		article.head div h2 {
			padding: 0 1rem;
			width: 100%;
			margin: 0;

			opacity: 0;
			/* changed */
			font-size: 0.8rem;
			text-transform: uppercase;
			
			font-style: italic;

			transition: all 0.3s ease;

			text-align: left;
		}
		article.head div a {
			min-width: 10rem;
			margin-left: 1rem;
			opacity: 0;

			text-decoration: none;
			color: white;

			display: flex;
			align-items: center;
			justify-content: center;
			/* changed */
			padding: 0.8rem 1.6rem;
			border-radius: 50vh;
			border: 2px solid white;
			transition: all 0.3s ease;
		}
		article.head div a:hover {
			text-decoration: none;
			color: #ff7a22;
			background: white;
		}
		article.head div a svg {
			/* changed */
			height: 0.9rem;
			width: auto;
		}
		article.head div a h3 {
			/* changed */
			font-size: 0.9rem;
			margin: 0;
			margin-left: 0.8rem;
			white-space: nowrap;
		}


		div.info{

					
			/* changed */
			padding: 0.4rem 0.8rem;
			overflow-y: scroll;
			border-radius: 10px;
			background-color: rgba(0, 0, 0, 0.25);
			
			-webkit-box-shadow: inset 0px -25px 20px -30px #000; 
			box-shadow: inset 0px -25px 20px -30px #000;

			
			scrollbar-width: 5px;
		}
		div.info::-webkit-scrollbar{
			width:5px;
			height: 2rem;
		}
		div.info::-webkit-scrollbar-track {
			display: none;
		}
		div.info::-webkit-scrollbar-thumb {
			background: #444;
			border-radius: 5px
		}
		div.info::-webkit-scrollbar-thumb:hover {
			background: #666; 
		}	


		article.info {
			border-radius: 10px;
			/* changed */
			margin: 0.8rem 0;
			/* changed */
			padding: 0 0.8rem;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		article.info:hover {
			background-color: rgba(0, 0, 0, 0.50);
		}
		article.info:nth-of-type(even){
			flex-direction: row-reverse;
		}
		article.info h1 {
			/*changed */
			padding: 0.4rem;
			/*changed */
			font-size: 1.6rem;
		}
		article.info p {
			/* changed */
			font-size: 0.9rem;
		}


	



	}

	@media only screen and (max-width: 800px){

		section {
			width: 100vw;
			height: 100vh;
			display: flex;
			/* changed */ 
			flex-direction: column;
			align-items: center;
			justify-content: flex-start;

			overflow: hidden;
		}

		article.head {
			/* changed */
			width: 80vw;
			/*  changed */
			height: auto;
			position: relative;
			/* changed */
			margin-left: 0rem;
			/* changed */
			margin-top: 16vh; 
			text-align: left;

			transition: all 0.3s ease;
		}
		article.head div {
			
			width: 100%;
			height: 100%;
			
			display: flex;
			align-items: flex-start;
			justify-content: center;
			/* changed */
			gap: 1rem;
			flex-direction: column;

		}
		article.head div h1 {
			width: 100%;
			margin: 0;
			padding: 0 1rem;
		
			opacity: 0;
			/* changed */
			font-size: 1.6rem;
			text-transform: uppercase;
			transition: all 0.3s ease;
		}
		article.head div h2 {
			padding: 0 1rem;
			width: 100%;
			margin: 0;

			opacity: 0;
			/* changed */
			font-size: 0.8rem;
			text-transform: uppercase;
			
			font-style: italic;

			transition: all 0.3s ease;

			text-align: left;
		}
		article.head div a {
			min-width: 10rem;
			margin-left: 1rem;
			opacity: 0;

			text-decoration: none;
			color: white;

			display: flex;
			align-items: center;
			justify-content: center;
			/* changed */
			padding: 0.8rem 1.6rem;
			border-radius: 50vh;
			border: 2px solid white;
			transition: all 0.3s ease;
		}
		article.head div a:hover {
			text-decoration: none;
			color: #ff7a22;
			background: white;
		}
		article.head div a svg {
			/* changed */
			height: 0.9rem;
			width: auto;
		}
		article.head div a h3 {
			/* changed */
			font-size: 0.9rem;
			margin: 0;
			/* changed */
			margin-left: 0.8rem;
			white-space: nowrap;
		}


		div.info{
			/* changed */
			width: 80vw;
			/* changed */
			height: 45vh;
			/* changed */
			margin-top: 2rem;
			/*changed all*/
			position: relative;
			top: 0;
			right: 0;
					
			/* changed */
			padding: 0.4rem 0.8rem;
			overflow-y: scroll;
			border-radius: 10px;
			background-color: rgba(0, 0, 0, 0.25);
			
			-webkit-box-shadow: inset 0px -25px 20px -30px #000; 
			box-shadow: inset 0px -25px 20px -30px #000;

			
			scrollbar-width: 5px;
		}
		div.info::-webkit-scrollbar{
			width:5px;
			height: 2rem;
		}
		div.info::-webkit-scrollbar-track {
			display: none;
		}
		div.info::-webkit-scrollbar-thumb {
			background: #444;
			border-radius: 5px
		}
		div.info::-webkit-scrollbar-thumb:hover {
			background: #666; 
		}	


		article.info {
			border-radius: 10px;
			/* changed */
			margin: 0.8rem 0;
			/* changed */
			padding: 0 0.8rem;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		article.info:hover {
			background-color: rgba(0, 0, 0, 0.50);
		}
		article.info:nth-of-type(even){
			flex-direction: row-reverse;
		}
		article.info h1 {
			/*changed */
			padding: 0.4rem;
			/*changed */
			font-size: 1.6rem;
		}
		article.info p {
			/* changed */
			font-size: 0.9rem;
		}


		img#background {
			position: absolute;
			/* changed */
			bottom: -5%;
			left: -2%;
			z-index: -10;

			/* changed */
			width: 92vw;
			/* changed */
			height: 90vh;
			/* changed */
			transform: scaleY(190%);
			opacity: 0.5;
		}
		.lht-container {
			position: absolute;
			/* changed */
			bottom: 55%;
			/* changed */
			left: 65vw;
			
			
			/* changed */
			padding: 0.8rem;
			border-radius: 10px;
		}
		svg#LHT {
			z-index: -5;
			/* changed */
			height: 3rem;
			width: auto;
		}

		svg#LHT #lht-t {
			animation-name: lht-move;
			animation-duration: 4.5s;
			animation-iteration-count: infinite;
		}
		svg#LHT #lht-l {
			animation-name: lht-move;
			animation-duration: 4s;
			animation-iteration-count: infinite;
		}
		svg#LHT #lht-h {
			animation-name: lht-move;
			animation-duration: 4.2s;
			animation-iteration-count: infinite;
		}

		.navbutton {
			position: absolute;
			width: 3rem;
			height: 3rem;
			top: 50%;
			left: 100%;
			transform: translate(-80%, -50%);

			display: flex;
			align-items: center;
			justify-content: flex-start;
			padding-left: 0.5rem;
			background-color: rgba(0, 0, 0, 0.5);
			border-radius: 50vh;
			transition: all 0.3s ease;
			cursor: pointer;
		}
		.navbutton svg {
			width: 1.5rem;
			height: 2rem;
		}
		.navbutton:hover{
			transform: translate(-90%, -50%) scale(140%);
			background-color: rgba(0, 0, 0, 0.75);
		}
		.navbutton2{
			position: absolute;
			width: 3rem;
			height: 3rem;
			top: 50%;
			right: 100%;
			transform: translate(80%, -50%);

			display: flex;
			align-items: center;
			justify-content: flex-start;
			padding-left: 0.9rem;
			background-color: rgba(0, 0, 0, 0.5);
			border-radius: 50vh;
			transition: all 0.3s ease;
			cursor: pointer;
		}
		.navbutton2 svg{
			width: 1.5rem;
			height: 2rem;
			transform: rotate(180deg);
		}
		.navbutton2:hover{
			transform: translate(90%, -50%) scale(140%);
			background-color: rgba(0, 0, 0, 0.75);
		}
	}

</style>
